import React, { memo } from 'react'
import tw from 'twin.macro'
import { Link, To } from 'react-router-dom'
import { Button } from 'src/components/shared/Button'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  label: string
  /** Navigate as a link (keeps open-in-new-tab and the URL on hover). */
  to?: To
  /** Router state carried by `to` — e.g. a list's query string so Back lands on the same view. */
  state?: unknown
  /** Use instead of `to` when going back needs logic (e.g. restoring a queue tab). */
  onClick?(): void
  dataTestId?: string
}

/**
 * The admin's one "Back to …" control: a small white button with a left chevron, as the document
 * review header introduced. Use it wherever a page links back up to its parent instead of a bare
 * underlined text link.
 */
const BackButtonComponent = ({ label, to, state, onClick, dataTestId }: Props) => {
  const button = (
    <Button
      size="small"
      color="white"
      leftIcon={<GSIcon iconName="gs_chevron_left_small" size={20} css={tw`text-shades-1000`} />}
      onClick={onClick}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  )

  if (to === undefined) {
    return button
  }

  return (
    <Link to={to} state={state} css={tw`self-start no-underline`} tabIndex={-1}>
      {button}
    </Link>
  )
}

export const BackButton = memo(BackButtonComponent)
